import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from "react-router-dom"; // Assuming you use OutletContext for user info
import { getAuthHeader, getToken, getUser } from "../utils/auth"; // Adjust path as needed

// --- 定数 ---
const API_URL = "https://salesbreaker.jp"; // SalesBreakerのURL
// ★★★ 修正箇所: ZIPファイルのURLをGoogle Driveに変更 ★★★
const EXTENSION_ZIP_URL = "https://drive.google.com/file/d/1zX__bvQ9okmtXdrEd--luw7qxKAAqrlX/view?usp=sharing";
// ★★★ 修正箇所: 画像のパス ★★★
// 以下のパスは、実際に画像をホスティングする場所に合わせて修正してください。
const IMAGE_PATH_ID = "/images/extensionid.png"; // extensionid.jpg のパス
const IMAGE_PATH_MAIN = "/images/extensionmain.png"; // extensionmain.png のパス
const IMAGE_PATH_SETTING = "/images/extensionsetting.png"; // extensionsetting.png のパス
// ★★★ 追加: Google Drive ダウンロード案内画像 ★★★
const IMAGE_PATH_GOOGLE_DRIVE_DL = "/images/extensiondlanauns.png"; // extensiondlanauns.png のパス
// ★★★ 追加: デベロッパーモード案内画像 ★★★
const IMAGE_PATH_DEV_MODE = "/images/extensiondlanauns2.png"; // extensiondlanauns2.png のパス


// --- アイコン ---
const DownloadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>;
const AlertCircleIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/></svg>;
const ChevronDownIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>;
const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm-12 12.586L3.84 8.207 10.049 2 14 5.951l-6.207 6.207-4.596 1.437L.646 12.854zm.756-1.060 3.37.989.989 3.37L1.646 16l-1-1 .756-.756z"/></svg>;
const SaveIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1z"/></svg>;
const PlusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg>;
const RocketLaunchIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 8c.828 0 1.5-.895 1.5-2S8.828 4 8 4s-1.5.895-1.5 2S7.172 8 8 8Z"/><path d="M11.913 11.025c-.117.611-.469 1.125-.927 1.491l-1.638.966c-.46.273-.972.453-1.493.504L8 14.024l-.001-.001-.004-.002-.013-.006a5.57 5.57 0 0 1-.034-.01l-.03-.012a3.493 3.493 0 0 1-.223-.114l-.175-.1a.5.5 0 0 1 .48-.868l.175.1c.064.035.122.077.175.123l.09.067c.214.156.45.287.692.381l1.638-.966c.31-.184.536-.49.626-.837l.044-.179c.046-.19.06-.381.052-.568l-.024-.595a.5.5 0 1 1 .99.106l.024.593c.012.305-.005.61-.067.91z"/><path d="M4.658 11.025c.117.611-.469 1.125-.927 1.491l1.638.966c.46.273.972.453 1.493.504l.123.019c.026.004.05.008.075.011l.074.01c.188.026.38.03.572.03s.384-.004.572-.03l-.074-.01a.556.556 0 0 1-.075-.011l-.123-.019c.52-.05.1033-.23.1493-.503l1.638-.967c.458-.366.81-.88.927-1.49l.044-.18c.046-.19.06-.381.052-.568l-.024-.595a.5.5 0 0 1 .99.106l.024.593c.014.305-.005.61-.067.91l-.044.18c-.115.447-.341.854-.65 1.17l-1.638.966c-.494.293-1.058.468-1.644.517l-.123.019a.487.487 0 0 1-.075.011l-.074.01c-.188.026-.38.03-.572.03s-.384-.004-.572-.03l-.074-.01a.556.556 0 0 1-.075-.011l-.123-.019c-.586-.049-1.15-.224-1.644-.517L5.311 12.9c-.31-.316-.536-.723-.65-1.17l-.044-.18a1.87 1.87 0 0 1-.067-.91l.024-.593a.5.5 0 0 1 .99-.106l-.024.595c-.008.187.006.378.052.568l.044.179z"/><path d="M5.5 10.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.5.5Z"/><path d="M12.99 8.24c.445.185.79.497.986.915l.044.1c.19.441.19.932 0 1.373l-.044.1c-.196.418-.54.73-.986.915l-1.594.664c-.445.185-.932.185-1.373 0l-1.594-.664c-.445-.185-.79-.497-.986-.915l-.044-.1c-.19-.441-.19-.932 0-1.373l.044-.1c.196-.418.54-.73.986.915l1.594-.664c.44-.185.928-.185 1.373 0l1.594.664Z"/></svg>;
// --- ローディングスピナー ---
const SmallSpinner = () => <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>;
// ★★★ 修正: XIconを追加 ★★★
const XIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>;


// --- ヘルパーコンポーネント ---
const Alert = ({ message, type = 'error', onClose }) => {
    const baseClasses = 'border-l-4 p-3 my-4 flex justify-between items-center rounded-md shadow-sm text-sm';
    const typeClasses = {
        error: 'bg-red-50 border-red-500 text-red-700',
        success: 'bg-green-50 border-green-500 text-green-700',
        info: 'bg-blue-50 border-blue-500 text-blue-700'
    };
    // プレビュー環境で alert が機能しないため、Alertコンポーネントを流用
    if (type === 'alert') {
        return (
             <div className={`${baseClasses} ${typeClasses['info']}`} role="alert">
                 <p className="font-medium mr-2">{message}</p>
                 {onClose && <button onClick={onClose} className="ml-3 font-bold text-xl hover:opacity-75 leading-none">&times;</button>}
             </div>
        );
    }
    return (
        <div className={`${baseClasses} ${typeClasses[type]}`} role="alert">
            <p className="font-medium mr-2">{message}</p>
            {onClose && <button onClick={onClose} className="ml-3 font-bold text-xl hover:opacity-75 leading-none">&times;</button>}
        </div>
    );
};

// --- メインコンポーネント ---
export default function ExtensionPage() {
    const { user: contextUser } = useOutletContext() || {}; // contextUserがnullの場合を考慮
    const [activeTab, setActiveTab] = useState('settings');
    const [registeredIds, setRegisteredIds] = useState([]);
    const [isLoadingIds, setIsLoadingIds] = useState(true);
    const [idError, setIdError] = useState(null);
    const [newLabel, setNewLabel] = useState('');
    const [newExtensionId, setNewExtensionId] = useState('');
    const [isAdding, setIsAdding] = useState(false);
    const [addError, setAddError] = useState(null);
    const [selectedLaunchId, setSelectedLaunchId] = useState('');
    const [isEditing, setIsEditing] = useState(null); // Holds the ID of the item being edited
    const [editLabel, setEditLabel] = useState('');
    const [editExtensionId, setEditExtensionId] = useState('');
    const [isSubmittingEdit, setIsSubmittingEdit] = useState(false); // ★ 編集保存中の状態を追加
    const [alertMessage, setAlertMessage] = useState(null); // alert() の代替

    // ユーザーID (API呼び出しで使用)
    // getUser() が null を返す可能性も考慮
    const user = contextUser || getUser(); // コンテキスト or モック
    const userId = user?.id;

    // 登録済みIDリストを取得する関数
    const fetchRegisteredIds = useCallback(async () => {
        if (!userId) {
             console.log("UserID not found, skipping fetchRegisteredIds.");
             setIsLoadingIds(false);
             return;
        }
        setIsLoadingIds(true);
        setIdError(null);
        try {
            const response = await fetch(`${API_URL}/api/user/extension-ids`, {
                headers: getAuthHeader(),
            });
            if (!response.ok) {
                 const errorText = await response.text();
                 let errorJson = {};
                 try { errorJson = JSON.parse(errorText); } catch(e) {/* ignore */}
                 throw new Error(errorJson.error || `Failed to fetch IDs (Status: ${response.status}) - ${errorText}`);
            }
            const data = await response.json();
             // モック用に success がなくても extensionIds があればOKとする
            if (data.success || data.extensionIds) {
                setRegisteredIds(data.extensionIds || []);
                // If a launch ID was selected, ensure it still exists
                if (selectedLaunchId && data.extensionIds && !data.extensionIds.some(item => item.id.toString() === selectedLaunchId)) {
                    setSelectedLaunchId(''); // Reset if no longer exists
                }
                // If no ID is selected for launch, try selecting the first available one
                if (!selectedLaunchId && data.extensionIds && data.extensionIds.length > 0) {
                     setSelectedLaunchId(data.extensionIds[0].id.toString());
                }
            } else {
                throw new Error(data.error || "API returned unknown error when fetching extension IDs.");
            }
        } catch (error) {
            console.error("Error fetching registered IDs:", error);
            setIdError(`IDリストの取得に失敗 (モック動作中?): ${error.message}`);
            // モックデータ
            setRegisteredIds([
                 { id: 1, label: "ダミーPC (モック)", extension_id: "abcdef123456" }
            ]);
            if (!selectedLaunchId) {
                setSelectedLaunchId("1");
            }
        } finally {
            setIsLoadingIds(false);
        }
    }, [userId, selectedLaunchId]); // selectedLaunchId も依存配列に追加

    // 初期表示時にIDリストを取得
    useEffect(() => {
        fetchRegisteredIds();
    }, [fetchRegisteredIds]);

    // 新しいIDを追加する関数
    const handleAddId = async (e) => {
        e.preventDefault();
        if (!newLabel || !newExtensionId) {
            setAddError("ラベルと拡張機能IDの両方を入力してください。");
            return;
        }
        setIsAdding(true);
        setAddError(null);
        try {
            const response = await fetch(`${API_URL}/api/user/extension-ids`, {
                method: 'POST',
                headers: getAuthHeader(true),
                body: JSON.stringify({ label: newLabel.trim(), extension_id: newExtensionId.trim() }), // Trim input
            });
             const data = await response.json();
             if (!response.ok || !data.success) {
                  const errorText = data.error || await response.text();
                  throw new Error(`Failed to add ID (Status: ${response.status}) - ${errorText}`);
             }
             setNewLabel('');
             setNewExtensionId('');
             await fetchRegisteredIds(); // Refresh the list
             // Show success temporarily
             const tempStatus = document.getElementById('add-status');
             if(tempStatus) {
                tempStatus.textContent = "追加しました！";
                tempStatus.className = "text-green-600 text-xs mt-1";
                setTimeout(() => { tempStatus.textContent = ""; }, 2000);
             }
        } catch (error) {
             console.error("Error adding ID:", error);
             setAddError(`追加エラー: ${error.message}`);
        } finally {
             setIsAdding(false);
        }
    };

    // IDを削除する関数
    const handleDeleteId = async (idToDelete) => {
        // window.confirm はプレビューで動作しないため、カスタムアラート（もどき）に変更
        // if (!window.confirm("このIDを削除してもよろしいですか？")) return;
        console.log("削除確認:", idToDelete); // コンソールには残す

        const originalIds = [...registeredIds];
        setRegisteredIds(prev => prev.filter(item => item.id !== idToDelete));
        setIdError(null);

        try {
            const response = await fetch(`${API_URL}/api/user/extension-ids/${idToDelete}`, {
                method: 'DELETE',
                headers: getAuthHeader(),
            });
             const data = await response.json();
             if (!response.ok || !data.success) {
                 setRegisteredIds(originalIds); // Revert UI on failure
                 throw new Error(data.error || `Failed to delete ID (Status: ${response.status})`);
             }
             // On success, UI is already updated
             // Show success temporarily
             const tempStatus = document.getElementById('list-status');
              if(tempStatus) {
                tempStatus.textContent = "削除しました。";
                tempStatus.className = "text-green-600 text-xs mt-1";
                setTimeout(() => { tempStatus.textContent = ""; }, 2000);
             }
             // If the deleted ID was selected for launch, reset selection
             if (selectedLaunchId === idToDelete.toString()) {
                 setSelectedLaunchId('');
             }

        } catch (error) {
             console.error("Error deleting ID:", error);
             setIdError(`削除エラー: ${error.message}`);
             setRegisteredIds(originalIds); // Revert UI on failure
        }
    };

    // 編集モードを開始
    const startEditing = (item) => {
        setIsEditing(item.id);
        setEditLabel(item.label);
        setEditExtensionId(item.extension_id);
        setIdError(null);
    };
    // 編集をキャンセル
     const cancelEditing = () => {
         setIsEditing(null);
         setEditLabel('');
         setEditExtensionId('');
         setIdError(null);
     };

    // 編集を保存
    const handleSaveEdit = async (idToUpdate) => {
         if (!editLabel.trim() || !editExtensionId.trim()) {
             setIdError("ラベルと拡張機能IDは必須です。");
             return;
         }
         setIsSubmittingEdit(true); // ★ Use dedicated submitting flag
         setIdError(null);
         try {
             const response = await fetch(`${API_URL}/api/user/extension-ids/${idToUpdate}`, {
                 method: 'PUT',
                 headers: getAuthHeader(true),
                 body: JSON.stringify({ label: editLabel.trim(), extension_id: editExtensionId.trim() }),
             });
             const data = await response.json();
             if (!response.ok || !data.success) {
                   const errorText = data.error || await response.text();
                   throw new Error(`Failed to update ID (Status: ${response.status}) - ${errorText}`);
             }
             setIsEditing(null); // Exit edit mode
             await fetchRegisteredIds(); // Refresh list
             // Show success temporarily
              const tempStatus = document.getElementById('list-status');
              if(tempStatus) {
                 tempStatus.textContent = "更新しました！";
                 tempStatus.className = "text-green-600 text-xs mt-1";
                 setTimeout(() => { tempStatus.textContent = ""; }, 2000);
              }
         } catch (error) {
             console.error("Error updating ID:", error);
             setIdError(`更新エラー: ${error.message}`);
             // Keep edit mode open on error to allow retry
         } finally {
              setIsSubmittingEdit(false); // ★ Use dedicated submitting flag
         }
    };


    // 拡張機能を起動する関数
    const handleLaunchExtension = () => {
        // alert() の代わりにカスタムアラート（もどき）を使用
        setAlertMessage(null); // 既存のメッセージをクリア
        const selectedItem = registeredIds.find(item => item.id.toString() === selectedLaunchId);
        if (!selectedItem) {
            setAlertMessage("起動する拡張機能IDを選択してください。リストからIDを選択するか、新しいIDを追加してください。");
            return;
        }

        const token = getToken();
        if (!token) {
            setAlertMessage("認証トークンが見つかりません。再ログインしてください。");
            return;
        }

        if (!user || !user.client_id) {
             setAlertMessage("クライアントIDが見つかりません。ユーザー情報が正しく読み込めていない可能性があります。");
             return;
        }

        const extensionUrl = `chrome-extension://${selectedItem.extension_id}/main.html?client_id=${user.client_id}&token=${token}`;
        console.log("Opening extension URL:", extensionUrl);
        // window.open はプレビュー環境のiFrameではブロックされる可能性がある
        window.open(extensionUrl, '_blank', 'noopener,noreferrer');
        setAlertMessage("起動を試みました。新しいタブが開かない場合は、ブラウザのポップアップブロック設定を確認してください。");
    };

    // タブ切り替え用のUI
    const TabButton = ({ target, label }) => (
        <button
            onClick={() => setActiveTab(target)}
            className={`px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-150 ease-in-out ${
                activeTab === target
                ? 'bg-indigo-600 text-white shadow-sm'
                : 'text-gray-600 hover:bg-gray-200 hover:text-gray-800'
            }`}
        >
            {label}
        </button>
    );

    return (
        <div className="p-3 sm:p-4 md:p-6 lg:p-8 bg-gray-100 min-h-screen">
            <h1 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-5 sm:mb-6">拡張機能 送信ツール</h1>
            
            {/* alert() の代替表示エリア */}
            {alertMessage && <Alert message={alertMessage} type="info" onClose={() => setAlertMessage(null)} />}

            <div className="mb-6 border-b border-gray-300 overflow-x-auto">
                <nav className="flex min-w-max space-x-2 sm:space-x-4 pb-2" aria-label="Tabs">
                    <TabButton target="settings" label="設定・ID管理" />
                    <TabButton target="usage" label="使い方・注意点" />
                </nav>
            </div>

            {/* --- 設定・ID管理 タブ --- */}
            <div className={activeTab === 'settings' ? '' : 'hidden'}>
                <section className="bg-white p-4 sm:p-6 rounded-lg shadow-md mb-6">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 border-b pb-2">1. 拡張機能のダウンロードとインストール</h2>
                    <div className="space-y-4 text-sm text-gray-600">
                        <p>以下のボタンから拡張機能のファイル (ZIP形式) をダウンロードしてください。</p>
                        
                        <a
                            href={EXTENSION_ZIP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex w-full items-center justify-center gap-2 bg-indigo-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-indigo-700 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                            <DownloadIcon /> 拡張機能をダウンロード (Google Drive)
                        </a>
                        
                         <div className="my-4 p-3 sm:p-4 border rounded-md bg-gray-50 flex flex-col items-center">
                             <p className="text-sm text-gray-700 mb-3">
                                 Google Driveが開いたら、下図の赤枠で囲まれたダウンロードボタンをクリックしてください。
                             </p>
                             <figure>
                                 <img 
                                     src={IMAGE_PATH_GOOGLE_DRIVE_DL} 
                                     alt="Google Drive のダウンロードボタンの位置を示す画像" 
                                     className="max-w-lg w-full rounded-md shadow-md border" 
                                     onError={(e) => { 
                                         e.target.style.display = 'none'; 
                                         const figcaption = e.target.nextSibling;
                                         if (figcaption) figcaption.innerHTML = '画像パスエラー: (IMAGE_PATH_GOOGLE_DRIVE_DL)';
                                     }}
                                 />
                                 <figcaption className="text-xs text-center text-gray-500 mt-2">Google Drive のダウンロードボタン</figcaption>
                             </figure>
                         </div>

                        <p className="font-medium mt-4 text-gray-700">インストール手順:</p>
                        {/* ★★★ 修正箇所: インストール手順にデベロッパーモードの画像を追加 ★★★ */}
                        <ol className="list-decimal list-inside space-y-2 pl-4">
                            <li>ダウンロードしたSalesBreakerExtension.zipを**解凍** (展開) してください。「SalesBreakerExtension」 という名前のフォルダが作成されます。</li>
                            <li>Chromeブラウザを開き、アドレスバーに 「chrome://extensions/」 と入力して拡張機能ページを開きます。</li>
                            {/* ★ 画像を追加 ★ */}
                            <li className="list-none my-4 p-3 sm:p-4 border rounded-md bg-gray-50 flex flex-col items-center">
                                 <p className="text-sm text-gray-700 mb-3 text-left self-start">
                                     拡張機能ページが開いたら、下図の①、②の順に操作します。
                                 </p>
                                <figure>
                                    <img 
                                        src={IMAGE_PATH_DEV_MODE} 
                                        alt="デベロッパーモードをオンにし、パッケージ化されていない拡張機能を読み込む手順" 
                                        className="max-w-2xl w-full rounded-md shadow-md border"
                                        onError={(e) => { 
                                             e.target.style.display = 'none'; 
                                             const figcaption = e.target.nextSibling;
                                             if (figcaption) figcaption.innerHTML = '画像パスエラー: (IMAGE_PATH_DEV_MODE)';
                                         }}
                                    />
                                     <figcaption className="text-xs text-center text-gray-500 mt-2">拡張機能ページの操作手順</figcaption>
                                </figure>
                            </li>
                            <li>ページの右上にある「**デベロッパー モード**」のスイッチをオンにします。(上図の①)</li>
                            <li>左上に表示される「**パッケージ化されていない拡張機能を読み込む**」ボタンをクリックします。(上図の②)</li>
                            <li>ファイル選択ダイアログが表示されたら、先ほど解凍して作成された **「SalesBreakerExtension」 フォルダ** を選択して「開く」または「フォルダを選択」をクリックします。<br/><strong className="text-red-600">※ ZIPファイルや、中の `dist` フォルダではなく、「SalesBreakerExtension」フォルダ全体を選択してください。</strong></li>
                            <li>Sales Breaker拡張機能のカードが表示されればインストール完了です。</li>
                        </ol>
                        {/* ★★★ 修正ここまで ★★★ */}
                    </div>
                </section>

                <section className="bg-white p-4 sm:p-6 rounded-lg shadow-md mb-6">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 border-b pb-2">2. 拡張機能IDの確認と登録</h2>
                     <div className="space-y-3 text-sm text-gray-600 mb-5">
                         <p>インストールした拡張機能には、お使いのChrome環境ごとに固有のIDが割り当てられます。以下の手順でIDを確認し、このページに登録してください。</p>
                         <ol className="list-decimal list-inside space-y-1 pl-4">
                            <li>「chrome://extensions/」 ページで、インストールしたSales Breaker拡張機能のカードを探します。</li>
                            <li>カードに表示されている **ID** (英数字の羅列) をコピーします。（下図参照）</li>
                         </ol>
                         <div className="my-4 p-3 sm:p-4 border rounded-md bg-gray-50 flex justify-center">
                             <figure>
                                 <img 
                                     src={IMAGE_PATH_ID} 
                                     alt="拡張機能IDの場所を示す画像" 
                                     className="max-w-xs w-full rounded-md shadow-md border"
                                     onError={(e) => { 
                                         e.target.style.display = 'none'; 
                                         const figcaption = e.target.nextSibling;
                                         if (figcaption) figcaption.innerHTML = '画像パスエラー: (IMAGE_PATH_ID)';
                                     }}
                                 />
                                 <figcaption className="text-xs text-center text-gray-500 mt-2">拡張機能カードに表示されるID</figcaption>
                             </figure>
                         </div>
                         <ol className="list-decimal list-inside space-y-1 pl-4" start="3">
                             <li>下の「新しいIDを追加」フォームで、どのPCやブラウザのIDか分かる**ラベル** (例: "会社デスクトップ", "自宅ノート") と、コピーした**拡張機能ID**を入力し、「追加」ボタンを押します。</li>
                             <li>複数のPCで利用する場合は、それぞれのPCでこの手順を繰り返してください。</li>
                         </ol>
                     </div>

                     {idError && <Alert message={idError} type="error" onClose={() => setIdError(null)} />}

                     <h3 className="text-md font-semibold text-gray-700 mb-2">登録済みIDリスト</h3>
                     <div id="list-status" className="h-4 mb-2"></div> {/* Status message area */}
                    {isLoadingIds ? (
                        <div className="flex items-center text-gray-500 italic"><SmallSpinner /><span className="ml-2">IDリストを読み込み中...</span></div>
                    ) : registeredIds.length === 0 ? (
                        <p className="text-gray-500 italic py-4">登録されているIDはありません。</p>
                    ) : (
                        <ul className="space-y-2 mb-4 max-h-60 overflow-y-auto border rounded-md p-3 bg-gray-50">
                            {registeredIds.map(item => (
                                <li key={item.id} className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-white p-2 border rounded shadow-sm gap-2">
                                    {isEditing === item.id ? (
                                        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full">
                                            <input
                                                type="text"
                                                value={editLabel}
                                                onChange={(e) => setEditLabel(e.target.value)}
                                                className="px-2 py-1 border rounded-md text-sm w-full sm:w-1/3"
                                                placeholder="ラベル"
                                            />
                                             <input
                                                type="text"
                                                value={editExtensionId}
                                                onChange={(e) => setEditExtensionId(e.target.value)}
                                                className="px-2 py-1 border rounded-md text-sm font-mono flex-grow w-full"
                                                placeholder="拡張機能ID"
                                            />
                                            <div className="flex items-center justify-end sm:justify-start gap-1 flex-shrink-0">
                                                <button onClick={() => handleSaveEdit(item.id)} disabled={isSubmittingEdit} className="p-1.5 text-green-600 hover:bg-green-100 rounded disabled:opacity-50" title="保存">
                                                    {isSubmittingEdit ? <SmallSpinner /> : <SaveIcon />}
                                                </button>
                                                <button onClick={cancelEditing} className="p-1.5 text-gray-500 hover:bg-gray-100 rounded" title="キャンセル">
                                                    <XIcon />
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="flex-grow break-words mr-2">
                                                <span className="font-medium text-gray-800">{item.label}</span>:
                                                <span className="ml-2 font-mono text-xs text-gray-600 block sm:inline">{item.extension_id}</span>
                                            </div>
                                            <div className="flex items-center space-x-1 flex-shrink-0">
                                                 <button onClick={() => startEditing(item)} className="p-1.5 text-blue-600 hover:bg-blue-100 rounded" title="編集">
                                                    <EditIcon />
                                                 </button>
                                                 <button onClick={() => handleDeleteId(item.id)} className="p-1.5 text-red-600 hover:bg-red-100 rounded" title="削除">
                                                    <TrashIcon />
                                                 </button>
                                            </div>
                                        </>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}

                    {/* 新規ID追加フォーム */}
                    <form onSubmit={handleAddId} className="border-t pt-4 mt-4">
                        <h3 className="text-md font-semibold text-gray-700 mb-2">新しいIDを追加</h3>
                        {addError && <Alert message={addError} type="error" onClose={() => setAddError(null)} />}
                         <div id="add-status" className="h-4 mb-2"></div> {/* Status message area */}
                        <div className="flex flex-col sm:flex-row items-end gap-3">
                            <div className="flex-grow w-full sm:w-auto">
                                <label htmlFor="newLabel" className="text-xs font-medium text-gray-600 block mb-1">ラベル (例: 会社PC)</label>
                                <input
                                    type="text"
                                    id="newLabel"
                                    value={newLabel}
                                    onChange={(e) => setNewLabel(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                    placeholder="どのPC/ブラウザか分かる名前"
                                    maxLength="100"
                                    required
                                />
                            </div>
                            <div className="flex-grow w-full sm:w-auto">
                                <label htmlFor="newExtensionId" className="text-xs font-medium text-gray-600 block mb-1">拡張機能ID</label>
                                <input
                                    type="text"
                                    id="newExtensionId"
                                    value={newExtensionId}
                                    onChange={(e) => setNewExtensionId(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                    placeholder="ChromeからコピーしたID"
                                    maxLength="100"
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={isAdding || isLoadingIds}
                                className="w-full sm:w-auto flex justify-center items-center gap-2 bg-gray-700 text-white font-semibold py-2 px-4 rounded-md hover:bg-gray-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                            >
                                {isAdding ? <SmallSpinner /> : <PlusIcon />} 追加
                            </button>
                        </div>
                    </form>
                </section>

                <section className="bg-white p-4 sm:p-6 rounded-lg shadow-md mb-6">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 border-b pb-2">3. 拡張機能の起動</h2>
                    <div className="space-y-3 text-sm text-gray-600 mb-4">
                        <p>拡張機能を利用するPC環境に対応するIDを選択し、「起動」ボタンを押してください。新しいタブで拡張機能が開きます。</p>
                        {registeredIds.length === 0 && !isLoadingIds && (
                             <Alert message="利用可能な拡張機能IDが登録されていません。上記の手順でIDを登録してください。" type="info" />
                        )}
                    </div>
                     <div className="flex flex-col sm:flex-row items-end gap-3">
                        <div className="flex-grow w-full sm:w-auto relative">
                             <label htmlFor="launchSelect" className="text-xs font-medium text-gray-600 block mb-1">起動する環境 (IDラベル)</label>
                             <select
                                 id="launchSelect"
                                 value={selectedLaunchId}
                                 onChange={(e) => setSelectedLaunchId(e.target.value)}
                                 disabled={isLoadingIds || registeredIds.length === 0}
                                 className="w-full appearance-none px-3 py-2 pr-8 border border-gray-300 rounded-md text-sm bg-white disabled:bg-gray-100 disabled:text-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                             >
                                 <option value="">-- 選択してください --</option>
                                 {registeredIds.map(item => (
                                     <option key={item.id} value={item.id.toString()}>
                                         {item.label} ({item.extension_id.substring(0, 8)}...)
                                     </option>
                                 ))}
                             </select>
                             <div className="absolute inset-y-0 right-0 top-6 flex items-center px-2 pointer-events-none text-gray-400">
                                 <ChevronDownIcon />
                             </div>
                        </div>
                        <button
                            onClick={handleLaunchExtension}
                            disabled={!selectedLaunchId || isLoadingIds}
                            className="w-full sm:w-auto flex justify-center items-center gap-2 bg-green-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                           <RocketLaunchIcon /> 選択した環境で拡張機能を起動
                        </button>
                    </div>
                </section>

                <section className="bg-white p-4 sm:p-6 rounded-lg shadow-md mb-6">
                     <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 border-b pb-2">4. 認証・確認画面があるフォームの扱い</h2>
                     <div className="space-y-3 text-sm text-gray-600">
                         <p>
                             多くのWebサイトでは認証画面や確認画面が導入されています。SalesBreakerは、これらを回避することを目的とした機能を案内しません。
                         </p>
                         <p className="font-medium">推奨される扱い:</p>
                         <ul className="list-disc list-inside pl-4 space-y-1">
                             <li>
                                 認証・確認画面が表示される場合は、送信不可または人手確認として扱い、送信先サイトの仕様や規約を尊重してください。
                             </li>
                         </ul>
                         <p className="mt-2 text-xs text-gray-500">
                             ※第三者の認証回避ツールの利用を推奨するものではありません。
                         </p>
                     </div>
                 </section>
            </div>

            {/* --- 使い方・注意点 タブ --- */}
            <div className={`space-y-6 ${activeTab === 'usage' ? '' : 'hidden'}`}>
                
                {/* ★★★ 追加: このツールについての説明 ★★★ */}
                <section className="bg-blue-50 border-l-4 border-blue-500 p-4 sm:p-6 rounded-lg shadow-md text-blue-800">
                    <h2 className="text-lg sm:text-xl font-semibold mb-3 border-b border-blue-300 pb-2 flex items-center gap-2">
                        <AlertCircleIcon /> この拡張機能（送信ツール）について
                    </h2>
                    <div className="space-y-3 text-sm">
                        <p>
                            このツールは、SalesBreakerの通常送信（サーバーからの送信）で失敗した送信先に対し、<strong>送信可否の確認や手動確認を補助する</strong>送信手段です。
                        </p>
                        <h3 className="font-semibold text-base mt-2">主な特徴:</h3>
                        <ul className="list-disc list-inside space-y-2 pl-4">
                            <li>
                                <strong>お客様ブラウザでの確認・送信支援:</strong><br/>
                                通常の送信はSalesBreakerのサーバーから行われますが、この拡張機能は<strong>お客様ご自身のPCのChromeブラウザ</strong>上で、フォーム表示や送信可否の確認を補助します。
                                送信先サイトの仕様や規約に応じ、認証・確認画面がある場合は送信不可または人手確認として扱います。
                            </li>
                            <li>
                                <strong>速度 vs 確認精度:</strong><br/>
                                サーバー送信（本丸サービス）は非常に高速ですが、この拡張機能はPC上で1件ずつ処理するため、<strong>送信速度は低速</strong>です。
                                主に「通常送信で失敗したリスト」に対して、時間をかけてでも成功させたい場合に利用することを推奨します。
                            </li>
                        </ul>
                    </div>
                </section>
                {/* ★★★ 追加ここまで ★★★ */}

                <section className="bg-white p-4 sm:p-6 rounded-lg shadow-md">
                    {/* ★ ユーザー指定のタイトルに変更 ★ */}
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 border-b pb-2">基本的な使い方</h2>
                    {/* ユーザー指定のテキストに修正 */}
                    <ol className="list-decimal list-inside space-y-3 text-sm text-gray-600 pl-4">
                        <li>「設定・ID管理」タブで拡張機能IDを登録後、「拡張機能を起動」ボタンを押します。</li>
                        <li>新しいタブで拡張機能の操作画面（下図参照）が開きます。</li>
                        <li>
                            （任意）最初に右上の**設定アイコン（歯車マーク）**をクリックし、設定画面（下図参照）でOpenAI APIキーや送信元情報を入力・保存します。
                        </li>
                        <li className="list-none my-4 p-3 sm:p-4 border rounded-md bg-gray-50 flex flex-col md:flex-row justify-center items-start gap-6">
                            <figure className="flex-1 min-w-0">
                                <img 
                                    src={IMAGE_PATH_MAIN} 
                                    alt="拡張機能のメイン操作画面" 
                                    className="max-w-md w-full rounded-md shadow-md border mx-auto"
                                    onError={(e) => { 
                                         e.target.style.display = 'none'; 
                                         const figcaption = e.target.nextSibling;
                                         if (figcaption) figcaption.innerHTML = '画像パスエラー: (IMAGE_PATH_MAIN)';
                                     }}
                                />
                                <figcaption className="text-xs text-center text-gray-500 mt-2">メイン操作画面 (URLと文面入力)</figcaption>
                            </figure>
                            <figure className="flex-1 min-w-0">
                                <img 
                                    src={IMAGE_PATH_SETTING} 
                                    alt="拡張機能の設定画面" 
                                    className="max-w-md w-full rounded-md shadow-md border mx-auto"
                                    onError={(e) => { 
                                         e.target.style.display = 'none'; 
                                         const figcaption = e.target.nextSibling;
                                         if (figcaption) figcaption.innerHTML = '画像パスエラー: (IMAGE_PATH_SETTING)';
                                     }}
                                />
                                <figcaption className="text-xs text-center text-gray-500 mt-2">設定画面 (設定アイコンから開く)</figcaption>
                            </figure>
                        </li>
                        <li>「送信先URLリスト」に送信したいWebサイトのURLを1行に1つずつ入力します。（例: `https://example.com/contact`）<br/>または、「失敗リストを読み込む」ボタンで、SalesBreaker側で過去に失敗したURLを読み込むこともできます。</li>
                        <li>「文面テンプレート」を選択するか、「件名」「本文」を直接入力します。本文中のURLは自動的にクリック追跡用の短縮URLに変換されます。</li>
                        <li>「送信を開始する」ボタンをクリックすると、設定条件に基づく送信処理が始まります。</li>
                        <li>画面下部のステータスパネルに進捗や結果が表示されます。</li>
                        <li>処理を途中で止めたい場合は、「送信を停止する」ボタンをクリックしてください。</li>
                    </ol>
                 </section>

                 <section className="bg-yellow-50 border-l-4 border-yellow-500 p-4 sm:p-6 rounded-lg shadow-md text-yellow-800">
                     <h2 className="text-lg sm:text-xl font-semibold mb-4 border-b border-yellow-300 pb-2 flex items-center gap-2"><AlertCircleIcon /> 重要な注意点</h2>
                     {/* ユーザー指定のテキストに修正 */}
                     <ul className="list-disc list-inside space-y-3 text-sm pl-4">
                         <li>
                             <strong className="font-semibold">動作環境について:</strong> この拡張機能は、**現在お使いのPCのChromeブラウザ内**で動作します。**ブラウザを閉じたり、PCをシャットダウン/スリープすると送信プロセスは停止します**。長時間の送信を行う場合は、PCとChromeを起動したままにしてください。
                         </li>
                         <li>
                             <strong className="font-semibold">送信対象の管理について:</strong> 拡張機能は入力されたURLリストに対し、**単純に上から順に送信**を試みます。SalesBreakerのような「送信済み除外」「クライアントNGリスト適用」といった**高度な絞り込み機能はありません**。重複送信等を防ぐため、**送信リストはユーザー側で慎重に管理**してください。「失敗リスト読み込み」は、あくまで失敗したURLを再入力する機能です。
                         </li>
                          <li>
                             <strong className="font-semibold">送信結果の反映タイミング:</strong> 拡張機能での送信結果（成功/失敗）やクリックログが、SalesBreakerの「送信履歴」や「案件管理」に反映されるまでには、**最大で約5分程度のタイムラグ**があります。リアルタイム反映ではありません。
                         </li>
                         <li>
                             <strong className="font-semibold">エラーと品質改善について:</strong> Webサイト側の変更等で送信が失敗することがあります。失敗結果はステータスパネルに表示されます。失敗が続く場合、SalesBreakerの管理者が解析ルールや送信可否判定の確認データを更新することで改善される可能性があります。
                         </li>
                         <li>
                             <strong className="font-semibold">PCへの負荷について:</strong> 一度に大量のURL（数千件など）を処理させると、お使いのPCのメモリ、CPU、ネットワークに負荷がかかり、ご自身のPC動作が不安定になる可能性があります。最初は数百件程度から試し、PCの様子を見ながら件数を調整することをお勧めします。
                         </li>
                         <li>
                             <strong className="font-semibold">利用規約の遵守:</strong> 拡張機能を利用したフォーム送信は、送信先Webサイトの利用規約やガイドラインに従って行ってください。短時間に大量の送信を行うなどの迷惑行為は絶対におやめください。
                         </li>
                     </ul>
                 </section>
            </div>
        </div>
    );
}
